import Request from './Request';

const Payment = () => {
  return <Request header="Payment"></Request>;
};

export default Payment;
